import { LinkUtils } from "@core/layout/utils/link.utils";
import { DojoRoutesEnum, NavigationBase } from "@core/layout/enums/layout-routes.enum";
import { SideNavItem } from "@core/layout/components/side-nav/models/side-nav-item.model";
import { SideNavIds } from "@core/layout/components/side-nav/enums/side-nav-ids.enum";

export const SIDE_NAV_ADMIN_DEV_ITEMS: SideNavItem[] = [
	{
		id: SideNavIds.ACCUEIL,
		icon: "home-alt",
		label: "Accueil",
		link: LinkUtils.generateLinkModel(NavigationBase.DOJO, DojoRoutesEnum.DASHBOARD),
	},
];
